<template>
  <v-tooltip v-if="value" bottom>
    <template v-slot:activator="{ on }">
      <v-icon v-if="value.length === 32" color="success" small v-on="on">check_circle_outline</v-icon>
      <v-icon v-else color="warning" small v-on="on">error_outline</v-icon>
    </template>
    <span>{{ value.length > 32 ? `${value.slice(0, 28)}...` : value }}</span>
  </v-tooltip>
  <v-icon v-else color="error" small>highlight_off</v-icon>
</template>

<script>
export default {
  name: 'ValidClickId',
  props: {
    value: {
      type: String,
      default: undefined,
    },
  },
}
</script>
